import Vue from 'vue';
import Router from 'vue-router';
import config from '@/config';
import {getToken} from '@/utils/cookie';
import {
  getAccessToken,
  refreshToken,
  getErpconfig,
  getValidMerchant,
  getQueryMenu,
  getSinglePageRoleCommon,
  nonexistent, getSinglePageHelp,
  checkAppVersion,
} from '@/utils/user';
import {
  getConfigurationItemData,
  getDistributorConfigurationItemData,
  getRouteMenuKey,
  showPageInitFailureModal,
  isInterceptorHandled,
  resetInterceptorHandled,
  isChunkLoadError,
  getRouteWithoutTicket,
  ensureSaasParamKeysData,
} from "@/utils/common";
import {validateConfigRouteAccess} from '@/utils/configRouteGuard';
import {clearAllLoading} from '@/utils/loading';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);
let countTime = config.curTime;
const routes = [
  {
    path: '/perfectInformation', // 完善信息
    component: () => import('@/components/common/perfectInformation')
  },
  {
    path: '/',
    redirect: '/commodityList',
    component: () => import('@/components/layout/distributor/main'), // 引入主文件
    children: [
      {
        path: '/noPersermission',
        component: () => import('@/components/common/noPersermission')
      },
      {
        path: '/distributionMarket', // 分销商后台系统---分销市场
        component: () => import('@/views/distributor/components/distributionMarketMange/distributionMarket')
      },
      {
        path: '/myInventory', // 分销商后台系统---商品管理--我的库存
        component: () => import('@/views/distributor/components/commodityManage/myInventory')
      },
      {
        path: '/commodityList', // 分销商后台系统---商品管理--收藏的商品
        component: () => import('@/views/distributor/components/commodityManage/commodityList')
      },
      {
        path: '/viewCollectSku', // 分销商后台系统---商品管理--收藏的商品--查看sku
        component: () => import('@/views/distributor/components/commodityManage/viewCollectSku')
      },
      {
        path: '/designedProductsList', // 分销商后台系统---商品管理--我设计的商品
        component: () => import('@/views/distributor/components/commodityManage/designedProductsList')
      },
      {
        path: '/viewCustomizedSku', // 分销商后台系统---商品管理--我设计的商品--查看sku
        component: () => import('@/views/distributor/components/commodityManage/viewCustomizedSku')
      },
      {
        path: '/generateSalesRecords', // 分销商后台系统---商品管理--生成售卖记录
        component: () => import('@/views/distributor/components/commodityManage/generateSalesRecords')
      },
      {
        path: '/automaticRules', // 分销商后台系统---自动规则
        component: () => import('@/views/distributor/components/automaticRulesManage/automaticRules')
      },
      {
        path: '/platformStoreList', // 分销商后台系统---店铺管理
        component: () => import('@/views/distributor/components/storeManage/platformStoreList')
      },
      /* {
         path: '/collectionSupplier', // 分销商后台系统---我的收藏---收藏的供应商
         component: () => import('@/views/distributor/components/myCollection/collectionSupplier')
       },*/
      {
        path: '/myOrder', // 分销商后台系统---订单管理--YMS订单
        component: () => import('@/views/distributor/components/orderManage/myOrder')
      },
      {
        path: '/addCloudSalesOrder', // 分销商后台系统---订单管理--添加YMS订单
        component: () => import('@/views/distributor/components/orderManage/addCloudSalesOrder'),
        meta: {
          parentPath: '/myOrder'
        }
      },
      {
        path: '/platformOrder', // 分销商后台系统---订单管理--平台订单
        name: 'platformOrder',
        component: () => import('@/views/distributor/components/orderManage/platformOrder')
      },
      {
        path: '/addTemuOrder', // 分销商后台系统---订单管理--平台订单---创建Temun订单
        component: () => import('@/views/distributor/components/orderManage/addTemuOrder'),
        meta: {
          parentPath: '/platformOrder'
        }
      },
      {
        path: '/myOrderDetails', // 分销商后台系统---订单管理--YMS订单--YMS订单详情
        component: () => import('@/views/distributor/components/orderManage/myOrderDetails'),
        meta: {
          parentPath: '/myOrder'
        }
      },
      {
        path: '/distributorStockList', // 分销商后台系统---订单管理--备货单
        component: () => import('@/views/distributor/components/orderManage/distributorStockList')
      },
      {
        path: '/createBackupOrder', // 分销商后台系统---订单管理--创建备货单
        component: () => import('@/views/distributor/components/orderManage/createBackupOrder'),
        meta: {
          parentPath: '/distributorStockList'
        }
      },
      {
        path: '/distributorStockListDetails', // 分销商后台系统---订单管理--备货单详情
        component: () => import('@/views/distributor/components/orderManage/distributorStockListDetails'),
        meta: {
          parentPath: '/distributorStockList'
        }
      },
      {
        path: '/paymentManagement', // 分销商后台系统---订单管理--付款管理
        component: () => import('@/views/distributor/components/orderManage/paymentManagement')
      },
      {
        path: '/orderImportTemplateList', // 分销商后台系统---订单管理--订单导入模板
        component: () => import('@/views/distributor/components/orderManage/orderImportTemplateList')
      },
      {
        path: '/rechargeRecord', // 分销商后台系统---财务管理--充值记录
        name: 'RechargeRecord',
        component: () => import('@/views/distributor/components/assetManage/rechargeRecord')
      },
      {
        path: '/financialJournal', // 分销商后台系统---财务管理---费用明细
        component: () => import('@/views/distributor/components/assetManage/financialJournal')
      },
      {
        path: '/basicInformation', // 分销商后台系统---账号管理--基本信息
        component: () => import('@/views/distributor/components/accountManage/basicInformation')
      },
      {
        path: '/securityInformation', // 分销商后台系统---账号管理--安全信息
        component: () => import('@/views/distributor/components/accountManage/securityInformation')
      },
      {
        path: '/modifyMobile', // 分销商后台系统---账号管理--安全信息--修改手机
        component: () => import('@/views/distributor/components/accountManage/modifyMobile'),
        meta: {
          parentPath: '/securityInformation'
        }
      },
      {
        path: '/modifyMailbox', // 分销商后台系统---账号管理--安全信息--修改邮箱
        component: () => import('@/views/distributor/components/accountManage/modifyMailbox'),
        meta: {
          parentPath: '/securityInformation'
        }
      },
      {
        path: '/modifyPassword', // 分销商后台系统---账号管理--安全信息--修改密码
        component: () => import('@/views/distributor/components/accountManage/modifyPassword'),
        meta: {
          parentPath: '/securityInformation'
        }
      },
      {
        path: '/iossManageList', // 分销商后台系统---账号管理--IOSS管理
        component: () => import('@/views/distributor/components/accountManage/iossManageList')
      },
      {
        path: '/logisticsSettings', // 分销商后台系统---物流管理--YMS物流
        component: () => import('@/views/distributor/components/logisticsManage/logisticsSettings')
      },
      {
        path: '/ownLogistics', // 分销商后台系统---物流管理--自有物流
        component: () => import('@/views/distributor/components/logisticsManage/ownLogistics')
      },
      {
        path: '/smartRule', // 分销商后台系统---物流管理--智能物流规则
        component: () => import('@/views/distributor/components/logisticsManage/smartRule.vue')
      },
      {
        path: '/repositoryList', // 分销商后台系统---仓库管理--仓库列表
        component: () => import('@/views/distributor/components/warehouseManage/repositoryList.vue')
      },
      {
        path: '/intelligentWarehouseRules', // 分销商后台系统---仓库管理--智能仓库规则
        component: () => import('@/views/distributor/components/warehouseManage/intelligentWarehouseRules.vue')
      },
      {
        path: '/complianceResponsiblePersonList', // 分销商后台系统---合规信息--合规责任人管理
        component: () => import('@/views/distributor/components/complianceInfoManage/complianceResponsiblePersonList.vue')
      },
      {
        path: '/manufacturerInfoList', // 分销商后台系统---合规信息--制造商信息管理
        component: () => import('@/views/distributor/components/complianceInfoManage/manufacturerInfoList.vue')
      },
      {
        path: '/roleManage', // 分销商后台系统---权限管理--角色管理
        component: () => import('@/views/distributor/components/permissionManage/roleManage')
      },
      {
        path: '/userManage', // 分销商后台系统---权限管理--用户管理
        component: () => import('@/views/distributor/components/permissionManage/userManage')
      },
      {
        path: '/newsList', // 分销商后台系统---账号管理--消息中心
        component: () => import('@/views/distributor/components/accountManage/newsList'),
        meta: {
          keepAlive: true    //开启缓存
        }
      },
      {
        path: '/newsListDetails', // 分销商后台系统---账号管理--消息中心--价格变动详情
        component: () => import('@/views/distributor/components/accountManage/newsListDetails')
      },
      {
        path: '/importTask', // 导入/导出任务--导入查看
        component: () => import('@/views/distributor/components/importExportTask/importTask')
      },
      {
        path: '/exportTask', // 导入/导出任务---导出查看
        component: () => import('@/views/distributor/components/importExportTask/exportTask')
      },
    ]
  },
  {
    path: '/viewGuideContent', // 查系统指引内容
    component: resolve => {
      require(['@/components/layout/viewGuideContent.vue'], resolve);
    }
  },
];

const router = new Router({
  mode: 'hash',
  routes
});

/**
 * 初始化分销商系统页面进入前需要的基础数据。
 * @param {string} menuKey 当前路由对应的菜单 key。
 * @returns {Promise<Object>} 初始化成功时返回 erpConfig。
 */
const initPageData = async (menuKey) => {
  const menu = await getQueryMenu();
  if (menu === null) {
    clearAllLoading();
    return null;
  }
  if (menu === false) {
    throw new Error('getQueryMenu failed');
  }
  const [erpConfig, role] = await Promise.all([
    getErpconfig('distributor'),
    getSinglePageRoleCommon(menuKey),
  ]);
  if (erpConfig === false) {
    throw new Error('getErpconfig failed');
  }
  if (role === false) {
    throw new Error('getSinglePageRoleCommon failed');
  }
  getSinglePageHelp(menuKey, 'ymsDistributor').catch((e) => {
    console.error('getSinglePageHelp non-blocking error:', e);
  });
  await getConfigurationItemData();
  return erpConfig && role ? erpConfig : null;
}

/**
 * 统一处理分销商系统页面初始化失败场景。
 * @param {Function} next vue-router 导航回调。
 * @param {Error} error 当前初始化异常。
 */
const handlePageInitFailure = (next, error) => {
  console.error('distributor router beforeEach error', error);
  if (isChunkLoadError(error)) {
    window.location.reload();
    return;
  }
  next(false);
  if (isInterceptorHandled) {
    resetInterceptorHandled();
    return;
  }
  showPageInitFailureModal();
}

router.beforeEach(async (to, from, next) => {
  try {
    // 前置检测：版本是否已更新
    const versionChanged = await checkAppVersion();
    if (versionChanged) {
      window.location.reload();
      return;
    }

    localStorage.setItem('system', 'distributor');
    const token = getToken();
    const menuKey = getRouteMenuKey(to, 'distributor');
    // 无权限 / 404 页面直接放行
    if (to.path === '/noPersermission') {
      await initPageData(menuKey);
      clearAllLoading();
      return next();
    }
    // token 处理
    let justLoggedIn = false;
    if (token) {
      refreshToken(countTime);
    } else {
      const access = await getAccessToken(to.fullPath, true);
      if (!access) {
        throw new Error('getAccessToken failed');
      }
      refreshToken(countTime);
      justLoggedIn = true;
    }
    // token 就绪后：登录成功或整页刷新时拉取 SaaS 配置
    await ensureSaasParamKeysData(to, justLoggedIn);
    const routeWithoutTicket = getRouteWithoutTicket(to);
    if (routeWithoutTicket) {
      clearAllLoading();
      return next(routeWithoutTicket);
    }
    // 初始化页面依赖
    const erpConfig = await initPageData(menuKey);
    if (erpConfig === null) {
      resetInterceptorHandled();
      return next(false);
    }
    // 配置项路由访问验证
    const configRouteAccess = validateConfigRouteAccess(to, 'distributor');
    if (!configRouteAccess) {
      return next(false);
    }
    if (erpConfig) {
      getValidMerchant();
      getDistributorConfigurationItemData();
      clearAllLoading();
      return nonexistent(to, next);
    }
  } catch (e) {
    handlePageInitFailure(next, e);
  }
});
// 路由错误处理
router.onError((error) => {
  if (isChunkLoadError(error)) {
    window.location.reload();
    return;
  }
  console.error('distributor router error:', error);
});

export default router;
